import React from 'react'
import { TextField } from '@mui/material'
import { useState } from 'react'
function MerText(props) {
    
    const [value,setValue] = useState(props.info.value);
    // const {info: {value}} = props;
    // console.log(props)
    
    return (
        <TextField 
        InputLabelProps={{
            style: { color: 'black', paddingLeft:'10px'},
        }}
        sx={{marginBottom:2,marginTop:2, maxWidth:'75%', 
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'black',
                },
           },
           '& .MuiFormLabel-asterisk': {
            color: 'red', fontSize: '30px', position: 'absolute', left: '-6px'
            }
        }}
        required={props.info.mandatory}
        autoComplete='off'
        value={value}
        disabled={!props.abled}
        onChange={(e) => {
            // if (props.info.mandatory && e.target.value && !props.info.value) {
            //     props.setMandatoryLeft(props.mandatoryLeft - 1)
            //     // console.log(props.mandatoryLeft)
            // }
            // if (props.info.mandatory && !e.target.value && props.info.value) {
            //     props.setMandatoryLeft(props.mandatoryLeft + 1)
            //     // console.log(props.mandatoryLeft)
            // }
            setValue(e.target.value);
            props.handleChange(props.info?.id,e.target.value,props.info?._id);
        }}
        label={props.info.question_text}
        variant="outlined"
        
        />
    )
}

export default MerText
